import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'
import AdminUserRoleScreen from './AdminUserRoleScreen'

const AdminUserRoleRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><AdminUserRoleScreen /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminUserRoleRoutes